// src/components/capCutoff.js
import cap1 from "../data/capf_1.json";
import cap2 from "../data/capf_2.json";
import cap3 from "../data/capf_3.json";
import cap4 from "../data/capf_4.json";

const roundFiles = { 
  1: cap1, 
  2: cap2, 
  3: cap3,
  4: cap4
};

const strip = (v) => String(v ?? "").trim();

// Figure out seat pool from code suffix: ...S / ...H / ...O / AI
const seatPoolFromCode = (code) => {
  const c = strip(code).toUpperCase();
  if (c.includes("AI")) return "AI";
  const last = c.slice(-1);
  if (last === "S") return "S";
  if (last === "H") return "H";
  if (last === "O") return "O";
  return "ALL";
};

// robust number parsing (handles "(88.95)", "88.95", "34,240")
const num = (s) => {
  const n = Number(String(s ?? "").replace(/[^\d.]/g, ""));
  return Number.isFinite(n) ? n : null;
};

// Normalizes a single cutoff tuple like ["GOPENS","37591","(88.9550679)"]
const normalizeCutoffTuple = ([code, a, b]) => {
  const n1 = num(a), n2 = num(b);
  let rank = null, percentile = null;

  const candidates = [n1, n2].filter((x) => x !== null);
  if (candidates.length) {
    const hi = Math.max(...candidates);
    const lo = Math.min(...candidates);
    if (hi > 100) rank = hi;          // rank is the larger one (>100)
    if (lo <= 100) percentile = lo;   // percentile is <=100
    // fallback if only one number present
    if (rank === null && percentile === null) {
      const only = candidates[0];
      if (only > 100) rank = only;
      else percentile = only;
    }
  }

  return {
    code: strip(code),
    pool: seatPoolFromCode(code),
    rank,
    percentile,
  };
};

// MAIN API used by both CollegeDetail and CutoffSheet
export const getCourseCutoffs = ({ round, courseId }) => {
  const data = roundFiles[round] || [];
  const id = strip(courseId);
  const course = data.find((row) => strip(row.Course_Id) === id);
  if (!course || !Array.isArray(course.cutoff)) return [];
  return course.cutoff.map(normalizeCutoffTuple).filter((r) => r.code);
};
